import Vue from 'vue'
import httpManager from '../../util/common'
let vm = {
  delimiters: ['{', '}'],
  model: {    
      prop: 'parentProp',
      event: 'parentEvent'
    },
  props: {
    parentProp:String,
    disabled:Boolean
  },
  data: () => {
    return {
      product_name: '',
      hints: [],
      showHintsBox: false,
      activeNo: -1,
      closeClick: false,
      check_product_name: '',
    } 
  },
  methods: {
    clear() {
      this.product_name = ''
    },
    productComplete () {
      let self = this
      let params = new Map()
      params.set('keyword', self.product_name)
      httpManager('product_search', params)
        .then(response => {
          self.hints = response.data.map(x => x.product_name)
          self.showHintsBox = true
        })
        .catch(error => {
          console.log(error)
        })
    },
    fillInput: function (index) {
      this.showHintsBox = false
      this.closeClick = true
      let value = this.hints[index]
      this.hints = []
      this.product_name = value
      this.check_product_name = this.product_name
      this.$emit('parentEvent', this.check_product_name)
    },
    closeHintsBox: function () {
      let self = this
      setTimeout(function () {
        self.showHintsBox = false
        self.hints = []
      }, 250)
    }
  },
  watch: {
    product_name: function () {
      this.$emit('parentEvent', this.product_name)
      if (!this.closeClick) {
        if (this.product_name === '') {
          this.closeHintsBox()
          this.$emit('parentEvent', null)
          return
        }
        let last = this.product_name
        setTimeout(()=>{
          if(last === this.product_name){
            this.productComplete()
          }
        },500)
      } else {
        this.closeClick = false
      }
      if(!this.product_name){
        this.check_product_name = null
      }
    },
  }
}
Vue.component('product-search', vm)
export default vm



// WEBPACK FOOTER //
// ./src/common/js/product_search.js